import { apiEndpoints } from 'settings/_apiSettings'
import axios from 'settings/axios'

interface GetProcedureCodeParams {
  treatmentId: string;
}

interface GetProcedureCodeResponse {
  code: string;
  type: string;
  description: string;
}

const getProcedureCode = async ({
  treatmentId,
}: GetProcedureCodeParams): Promise<GetProcedureCodeResponse> => {
  const endpoint = apiEndpoints.PATIENTS_PROCEDURE_CODE(treatmentId)
  const result: GetProcedureCodeResponse = await axios.get(endpoint)
  return result
}

export {
  getProcedureCode
}

